module.exports = __webpack_public_path__ + "image/danghui.png";